import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMobileDashboardFunds = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={40} height={40} fill='none' {...props}>
    <rect width={40} height={40} fill='#9575CD' rx={8} />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M25.625 18.665v6.585c0 1.5-.375 2.25-2.25 2.25h-6.75c-1.875 0-2.25-.75-2.25-2.25v-6.585M14.75 12.5h10.5q2.25 0 2.25 2.25v1.5q0 2.25-2.25 2.25h-10.5q-2.25 0-2.25-2.25v-1.5q0-2.25 2.25-2.25M18.635 21.5h2.73'
    />
  </svg>
);
export default SvgMobileDashboardFunds;
